import type { RootState } from 'client/js/redux/types/redux.types';
import type { CostFileTemplate } from '../../../../../../shared/types/roi-hub/fileIngestion.types';
import type { DataAction } from '../../../types/dataAction.type';
import { getPartners } from '../../AdPartner/AdPartner.selectors';
import {
  CostFileTemplateAdapterService,
  type EditCostFileTemplatePayload,
} from '../services/CostFileTemplateAdapterService';

export const EDIT_COST_FILE_TEMPLATE = 'EDIT_COST_FILE_TEMPLATE' as const;

export const editCostFileTemplate = (costFileTemplate: CostFileTemplate) => (dispatch: any, getState: () => RootState) => {
  const state = getState();
  const adPartners = getPartners(state);
  const costFileTemplateAdapter = new CostFileTemplateAdapterService();
  return dispatch({
    type: EDIT_COST_FILE_TEMPLATE,
    data: costFileTemplateAdapter.apiToEditPayload(costFileTemplate, adPartners),
  });
};

export type EditCostFileTemplateAction = DataAction<typeof EDIT_COST_FILE_TEMPLATE, EditCostFileTemplatePayload>;
